import { useMemo } from 'react';

import useActiveCourse from '@/data/hook/course-progress/useActiveCourse';
import { createLessonNameFormatter } from '@/utils/lesson/nameFormatterFactory';

export default function useLessonNameFormatter() {
  const { course, isLoading } = useActiveCourse();
  const formatter = createLessonNameFormatter(course);

  return useMemo(() => ({ ...formatter, isLoading }), [formatter, isLoading]);
}
